package provider

import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp

@Suppress("unused")
val LocalDisplayProvider =
    staticCompositionLocalOf<CommonDisplayProvider> { error("CommonDisplayProvider is not implemented by CompositionLocalProvider") }

data class Resolution(
    val width: Float,
    val height: Float,
    val dpi: Float,
) {
    @Suppress("unused")
    fun pxToDp(px: Number): Dp {
        return (px.toFloat() / dpi).dp
    }
}

abstract class CommonDisplayProvider {

    abstract val isMobile: Boolean

    abstract val isMobileOrSmall: Boolean

    abstract var resolution: Resolution
        protected set

    abstract var resolutionDp: DpSize
        protected set

    fun isLand() = resolution.width > resolution.height
}
